import {
  Box,
  Button,
  Typography,
  IconClear,
  useLayout,
  theme,
  IconDone,
} from '@capitalise/ui-design-system';
import AccountantsRidingBike from 'assets/svgs/accountants-riding-bike.svg';
import { tips } from './data';
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { Analytics } from 'utils/Analytics';
import { AnalyticsEventAction, AnalyticsEventCategory } from 'enums/analytics-types';
import { PaymentOrigin, useRedirectTrackingPaymentOrigin } from '@capitalise/common';

const DriverSidePanel = () => {
  const { closeRightBarOverlay } = useLayout();
  const location = useLocation();
  const { redirectToPaymentFlow } = useRedirectTrackingPaymentOrigin();

  const redirectToComparePlans = () => {
    const pathname = location.pathname;
    Analytics.track(
      AnalyticsEventCategory.profile,
      AnalyticsEventAction.applicationDriverComparePlans,
    );
    Analytics.track(AnalyticsEventCategory.business, AnalyticsEventAction.upgradeStart, {
      extraParams: {
        upgradeOrigin: `funding-driver`,
      },
    });
    redirectToPaymentFlow(PaymentOrigin.FUNDING, { path: pathname });
  };

  useEffect(() => {
    Analytics.track(
      AnalyticsEventCategory.profile,
      AnalyticsEventAction.applicationDriverFindOutMore,
    );
  }, []);

  return (
    <Box display="flex" flexDirection="column" height="100%" overflowY="auto">
      <Box position="relative" padding={{ _: '3xsmall', md: 'xlarge' }}>
        <Box
          height="small"
          width="small"
          borderRadius="50%"
          display="flex"
          justifyContent="center"
          alignItems="center"
          marginLeft="tiny"
          backgroundColor="grey-50"
          cursor="pointer"
          position="absolute"
          right={theme.sizes['xsmall']}
          top={theme.sizes['xsmall']}
          onClick={closeRightBarOverlay}
        >
          <IconClear width="3xsmall" color="grey-500" />
        </Box>
        <Box marginBottom="3xsmall" marginTop="2xlarge">
          <Typography size="section-header-14" color="grey-500">
            upgrade your account
          </Typography>
        </Box>
        <Box marginBottom="xsmall">
          <Typography size="heading-28">
            See your business credit score as banks and lenders see it
          </Typography>
        </Box>
        {tips.map((tip, index) => (
          <Box key={`tip_${index}`} flexPosition="start start" mt="3xsmall">
            <Box flexShrink="0">
              <IconDone color="green" />
            </Box>
            <Typography ml="tiny" size="body-16" color="grey-900">
              {tip}
            </Typography>
          </Box>
        ))}
        <Box mt="xsmall">
          <Button
            baseColor="green"
            data-testid="get-pro-button"
            onClick={redirectToComparePlans}
            fullWidth
          >
            <Box paddingX="tiny">
              <Typography size="heading-16" color="white">
                Compare plans
              </Typography>
            </Box>
          </Button>
        </Box>
      </Box>
      <Box marginTop="auto" alignItems="center" paddingX={{ _: '3xsmall', md: '3xlarge' }}>
        <AccountantsRidingBike />
      </Box>
    </Box>
  );
};

export default DriverSidePanel;
